import { TileAddress } from "./address/tiles.address";
import { FetchError, FetchResult, WebClient } from "../io";
export class TileWebClient extends WebClient {
    constructor(name, urlFactory, codec, metrics, options) {
        super(name, codec, urlFactory, options);
        this._metrics = metrics;
        this._zindex = 0;
    }
    get zindex() {
        return this._zindex;
    }
    set zindex(v) {
        this._zindex = v;
    }
    get metrics() {
        return this._metrics;
    }
    async fetchAsync(request, env, ...userArgs) {
        if (!request) {
            throw new FetchError(`invalid request parameter.`);
        }
        if (TileAddress.IsValidAddress(request, this._metrics) === false) {
            return FetchResult.Null(request, userArgs);
        }
        return super.fetchAsync(request, env, ...userArgs);
    }
}
//# sourceMappingURL=tiles.client.js.map